import { createAction, createSlice } from "@reduxjs/toolkit";

interface initialState {
    loading: boolean;
    error: string | null;
    comments: any[];
    commentsCount: number;
    commentText?: string;
    changeLog?: any[];
}

export const initialState: initialState = {
    loading: false,
    error: null,
    comments: [],
    commentsCount: 0,
    commentText: '',
    changeLog: [],
};

export const getCaseComments = createAction("comments/getCaseComments");
export const getPostComments = createAction("comments/getPostComments");
export const getDeleteComments = createAction("comments/getDeleteComments");
export const getChangeLog = createAction("comments/getChangeLog");

const commentSlice = createSlice({
    name: 'comments',
    initialState,
    reducers: {
        setCaseComments(state, action) {
            state.comments = action?.payload || [];
            state.commentsCount = action?.payload?.length || 0;
        },
        setCommentText(state, action) {
            state.commentText = action?.payload || "";
        },
        setChangeLog(state, action) {
            state.changeLog = action?.payload || [];
        },
        setLoading(state, action) {
            state.loading = action?.payload;
        },
        setError(state, action) {
            state.error = action?.payload;
        },
    },
});

export const { setCaseComments, setCommentText, setChangeLog, setLoading, setError } = commentSlice.actions;

export default commentSlice.reducer;